import React, { useState } from "react";
import "./Contact.css";

function Contact() {
  const [result, setResult] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    try {
      const formData = new FormData(event.target);
      formData.append("access_key", import.meta.env.VITE_WEB3FORMS_KEY);
      formData.append("subject", "New Contact Form Message from Website");

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setResult("✅ Message sent successfully! We’ll reply soon.");
        event.target.reset();
      } else {
        setResult("❌ Failed to send message. Please try again.");
      }
    } catch (error) {
      setResult("❌ Network error. Please try again later.");
    }
  };

  return (
    <div className="contact-page">
      {/* Banner */}
      <div className="contact-banner">
        <h1>Contact Us</h1>
      </div>

      <div className="contact-container">
        {/* Left Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Full Name" required />
          <input type="email" name="email" placeholder="Email Address" required />
          <input type="tel" name="phone" placeholder="Mobile Number" required />
          <textarea name="message" placeholder="Your Message" required></textarea>

          {/* Honeypot */}
          <input type="checkbox" name="botcheck" className="hidden" style={{ display: "none" }} />

          <button type="submit" disabled={result.startsWith("Sending")}>
            {result.startsWith("Sending") ? "SENDING..." : "SUBMIT MESSAGE"}
          </button>

          {result && <p className={`form-status ${result.includes("✅") ? "success" : result.includes("❌") ? "error" : ""}`}>{result}</p>}
        </form>

        {/* Right Info */}
        <div className="contact-info">
          <p className="small-title">CONTACT US NOW</p>
          <h2>Get in Touch With Us</h2>
          <p>
            We’re always available to assist you. Reach out to us for inquiries, support, or business partnerships.
          </p>

          <div className="info-cards">
            <div className="info-card">
              <h3>Phone & Email</h3>
              <p>
                📧 reclacac@gmail.com <br />
                📧 support@recla.in <br />
                📞 +234 816 940 5098
              </p>
            </div>

            <div className="info-card">
              <h3>Head Office – Aba</h3>
              <p>
                No. 77, GRA Umuebeke Street, Aba <br />
                Abia State, 
                Nigeria
              </p>
            </div>

            <div className="info-card">
              <h3>Minna Branch</h3>
              <p>
                No. 140, Off General Hospital Road, Minna, <br />
                Niger State,  Nigeria
               
              </p>
            </div>

            <div className="info-card">
              <h3>Abuja Branch</h3>
              <p>
                Danziyal Shopping Plaza, <br />
                Opposite NNPC Mega Station, <br />
                Central Area, Abuja, <br />
                Shop No. B32, Nigeria
              
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3974.265494551487!2d7.3431375!3d5.060657000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x10429c2cd7cf00df%3A0x26ebd2c32ab97aa0!2s77%20Umuebeke%20St%2C%20Aba%20450103%2C%20Abia%2C%20Nigeria!5e0!3m2!1sen!2sin!4v1761988255408!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Head Office Location"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;